export class LanguageListModel {
    id?: number;
    name?: string | undefined;
    shortCode?: string | undefined;
    code?: string | undefined;
    flagImageUrl?: string | undefined;
    isDefault?: boolean;
}

export class LanguageListModelListBaseResponse {
    isSuccess?: boolean;
    message?: string | undefined;
    successWarningMessage?: string | undefined;
    successErrorMessage?: string | undefined;
    additionalInformation?: string | undefined;
    result?: LanguageListModel[] | undefined;
}
